import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {Localization} from '../../../../projects/common/src/lib/interface/localization.extension';
import {StringsService} from '../../../../projects/common/src/lib/services/strings.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Folder} from '../../common/model/folder';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-rename-project-popup',
  templateUrl: 'rename-project.popup.html',
  styleUrls: ['../../styles/common.scss', 'rename-project.popup.scss']
})
export class RenameProjectPopup extends Localization {
  data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<RenameProjectPopup>>(MatDialogRef);


  project: Folder;
  isNew: boolean;

  constructor() {

    super();
    const data = this.data;

    this.project = data.project;
    this.isNew = data.isNew;
    if (!this.project) {
      this.dialogRef.close(null);
      return;
    }
  }

  /** Blank or spaces-only saved an item that showed with no name in the list. */
  hasName(): boolean {
    return !!this.project.name?.trim();
  }

  save() {
    if (!this.hasName()) {
      return;
    }
    this.project.name = this.project.name.trim();
    if (this.isNew) {
      this.dialogRef.close(this.project);
      return;
    }
    // A rename hands back only what it edits: the caller writes the result to
    // the item, and the whole copy carried every other field as it was when
    // the dialog opened (members, access level, tax rate...), undoing changes
    // made elsewhere in the meantime.
    this.dialogRef.close({name: this.project.name, description: this.project.description ?? ''});
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
